const getTotalCounts = counts => {
  let totalTotal = 0
  let draftTotal = 0
  let publishedTotal = 0
  let qualityReviewTotal = 0
  let rejectedTotal = 0
  let copyEditTotal = 0
  let internalReviewTotal = 0

  counts.forEach(o => {
    totalTotal = totalTotal + o.total_count
  })
  counts.forEach(o => {
    draftTotal = draftTotal + o.draft_count
  })
  counts.forEach(o => {
    publishedTotal = publishedTotal + o.published_count
  })
  counts.forEach(o => {
    qualityReviewTotal = qualityReviewTotal + o.quality_review_count
  })
  counts.forEach(o => {
    copyEditTotal = copyEditTotal + o.copy_edit_count
  })
  counts.forEach(o => {
    internalReviewTotal = internalReviewTotal + o.internal_review_count
  })
  counts.forEach(o => {
    rejectedTotal = rejectedTotal + o.rejected_count
  })

  return {
    totalTotal,
    draftTotal,
    publishedTotal,
    qualityReviewTotal,
    rejectedTotal,
    copyEditTotal,
    internalReviewTotal
  }
}

const getAttrCount = attr =>
  function (acc, obj) {
    return acc + obj[attr]
  }

const getFilterQuery = filterState => {
  let query = {}

  if (filterState.reviewing_compiled_quest_state_null) {
    query.reviewing_compiled_quest_state_null =
      filterState.reviewing_compiled_quest_state_null
  }

  if (filterState.authors_id_in && filterState.authors_id_in.length > 0) {
    query.authors_id_in = filterState.authors_id_in
  }

  if (filterState.questtags_id_in && filterState.questtags_id_in.length > 0) {
    query.questtags_id_in = filterState.questtags_id_in
  }

  if (
    filterState.reviewing_compiled_quest_state_in &&
    filterState.reviewing_compiled_quest_state_in.length > 0
  ) {
    query.reviewing_compiled_quest_state_in =
      filterState.reviewing_compiled_quest_state_in
  }

  if (
    filterState.name_or_description_cont &&
    filterState.name_or_description_cont.trim() !== ''
  ) {
    query.name_or_description_cont = filterState.name_or_description_cont
  }

  if (
    filterState.quest_subject_id_in &&
    filterState.quest_subject_id_in.length > 0
  ) {
    query.quest_subject_id_in = filterState.quest_subject_id_in
  }

  if (
    filterState.assigned_to_id_in &&
    filterState.assigned_to_id_in.length > 0
  ) {
    query.assigned_to_id_in = filterState.assigned_to_id_in
  }

  if (
    filterState.grade_levels_id_in &&
    filterState.grade_levels_id_in.length > 0
  ) {
    query.grade_levels_id_in = filterState.grade_levels_id_in
  }

  if (filterState.state_in && filterState.state_in.length > 0) {
    query.state_in = filterState.state_in
  }

  // storing object in redux, sending array of one id to BE
  if (filterState.mock_course_id_in) {
    query.mock_course_id_in = [filterState.mock_course_id_in.id]
  }

  if (filterState.mock_level_id_in && filterState.mock_level_id_in.length > 0) {
    query.mock_level_id_in = filterState.mock_level_id_in
  }

  if (filterState.need_final_review) {
    query.need_final_review = filterState.need_final_review
  }

  if (filterState.need_standards_review) {
    query.need_standards_review = filterState.need_standards_review
  }

  return query
}

const hasNoQuests = states => states.every(state => state.total_count === 0)

export { getTotalCounts, getAttrCount, getFilterQuery, hasNoQuests }



// WEBPACK FOOTER //
// ./src/utils/productionstatus.js